import { useCallback } from "react";
import type React from "react";

interface LockedLoaderImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Источник изображения.
   * Может быть:
   * - Путь из public папки (например, "/images/example.png")
   * - Абсолютный URL (например, "https://example.com/image.jpg")
   */
  src: string;

  /**
   * Альтернативный текст изображения.
   */
  alt: string;

  /**
   * CSS классы для контейнера изображения.
   */
  containerClassName?: string;
}

/**
 * Компонент защищённого изображения.
 *
 * Особенности:
 * - Блокирует контекстное меню.
 * - Запрещает перетаскивание изображения.
 * - Работает с локальными файлами и URL.
 */
export default function LockedLoaderImage({
  src,
  alt,
  containerClassName = "",
  ...rest
}: LockedLoaderImageProps) {
  /**
   * Запрет открытия контекстного меню.
   */
  const handleContextMenu = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
    },
    []
  );

  /**
   * Запрет drag'n'drop изображения.
   */
  const handleDragStart = useCallback(
    (e: React.DragEvent<HTMLImageElement>) => {
      e.preventDefault();
    },
    []
  );

  return (
    <div
      className={`relative select-none ${containerClassName}`}
      onContextMenu={handleContextMenu}
    >
      <img
        src={src}
        alt={alt}
        draggable={false}
        onDragStart={handleDragStart}
        {...rest}
      />

      {/* Прозрачный слой поверх изображения */}
      <div className="absolute inset-0 bg-transparent pointer-events-none" />
    </div>
  );
}